import { Box } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"
import type { ChatDataMessagePart, ChatFileMessagePart, ChatMessage, ChatMessagePart } from "@mui/x-chat-headless"
import { AttachmentFilePart, FileMessagePart } from "./attachment-file-part"

const ROW_SX = { display: "flex", flexWrap: "wrap", justifyContent: "flex-end", gap: 0.5 } satisfies SxProps<Theme>

type AttachmentPart = ChatDataMessagePart | ChatFileMessagePart

function isAttachmentPart(part: ChatMessagePart): part is AttachmentPart {
  return part.type === "file" || part.type === "data-attachment"
}

export function attachmentPartsOf(message: ChatMessage | null | undefined): AttachmentPart[] {
  return message == null ? [] : message.parts.filter(isAttachmentPart)
}

export function hasBubbleContent(message: ChatMessage | null | undefined): boolean {
  if (message == null) return false
  return message.parts.some((part) => {
    if (isAttachmentPart(part)) return false
    if (part.type === "text") return part.text.trim() !== ""
    return true
  })
}

export function MessageAttachments({ parts, message }: { parts: AttachmentPart[], message: ChatMessage }) {
  if (parts.length === 0) return null
  return (
    <Box sx={ROW_SX}>
      {parts.map((part, index) => (part.type === "file"
        ? <FileMessagePart key={`${part.filename ?? "file"}-${index}`} part={part} message={message} index={index} />
        : <AttachmentFilePart key={part.id ?? index} part={part} message={message} index={index} />))}
    </Box>
  )
}
